// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"RenderCheckboxInput_checkBox__3tRCO","checkArea":"RenderCheckboxInput_checkArea__2Fnne"};